enum PersistedSettingsActionTypes {
  SET_SETTINGS_VALUE = '@@persistedSettings/SET_SETTINGS_VALUE',
}

export interface PersistedSettingsTypes {
  hideArchivedData: boolean;
}

export { PersistedSettingsActionTypes };
